<template>
  <div class="wrapper">
    <div class="insure_header" style="background-color: #FF8E00; padding-bottom: 3.2rem;">
      <img class="header_img" :src="require('@/assets/imgs/driver_head.png')" />
      <div class="category" style="margin: 0 5%; width: 90%;">
        <van-tabs v-model="itemIndex" @click="onClick">
          <van-tab v-for="(item,idx) in tabList" :key="idx" :name="item.id" :title="item.name">
            <div class="insure_box">
              <div class="header">
                <i></i>
                <label>保障范围</label>
              </div>
              <div class="content">
                <div
                  class="content-item"
                  v-for="(item1,idx1) in JSON.parse(item.clauseJson)"
                  :key="idx1"
                >
                  <div class="top">
                    <div class="left">{{ item1.name }}</div>
                    <div class="right">{{ item1.claims }}</div>
                  </div>
                  <div class="center">{{item1.content}}</div>
                  <div class="bottom">{{item1.show}}</div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>

      <div id="explain">
        <h2>特别约定</h2>
        <h3>1、本保险的保险对象为符合《机动车驾驶证申领和使用规定》在获得政府主管部门批准成立的机动车驾驶培训机构参加机动车辆驾驶培训学习的学员。</h3>
        <h3>2、保险期间内,被保险人(学员)参加机动车驾驶人考试,若单科考试成绩未达到达标标准(科目一、科目二、科目三),根据约定,在实际补考金额内,每科最多赔付4次,累计赔付金额不超过800元。科目一赔偿标准最高标准为25元/次,科目二赔偿标准最高标准为100元/次,科目三赔偿标准最高标准为75元/次</h3>
        <h3>3、本保险限投保一份,多投无效。</h3>

        <h2>重要提示</h2>
        <h3>1、阳光财产保险股份有限公司已对保险条款,特别是保险责任及责任免除履行了明确说明义务,请投保人在充分理解条款的前提下投保本保险产品。</h3>
        <h3>
          2、父母为其未年满18周岁的子女投保本保险合同,还投保了其他
          人身保险合同的,在被保险人年满18周岁之前,本保险合同与其他保险合同约定
          的被保险人死亡给付的保险金额总和、被保险人死亡时本保险人与其他保险人实际给付的保险金总和均不得违反中国保险监督管理委员会关于父母
          为其未成年子投保以死亡为给付保险金条件人身保险的相关规定。
        </h3>
        <h3>
          3、投保人同意并授权阳光保险,基于为投保人提供更优质服务和 产品的目的,可以向阳光保险的业务合作伙伴共享、查询、收集投
          保人的信息,可以将投保人提供给阳光保险的信息、享受阳光保险 服务产生的信息(包括本条款签署之前提供和产生的信息)以及阳
          光保险根据本条款约定查询、收集的信息,用于阳光保险或其业务 合作伙伴为投保人提供服务、推荐产品、开展市场调查与数据分析
          法律另有规定的除外。投保人保证向阳光保险提供的第三方(包 括但不限于被保险人)个人信息已获得该第三方的同意和授权,阳
          光保险可以收集保存该第三方个人信息并且可用于数据分析及提供 本单证项下服务。阳光保险及其业务合作伙伴对上述信息负有保密
          义务,并采取措施保证信息安全。本条款自本单证签署时生效, 有独立法律效力,不受合同成立与否及效力状态变化的影响。本条
          款所称“阳光保险”是指阳光保险团股份有限公司及其关联公司。 如您不同意上述条款的部分或全部,可关注“阳光财险”微信公众
          号,在“个人信息”页面取消授权,或携带有效证件到我司营业网 点办理取消授权。
        </h3>
        <h3>4、本保单未尽事宜,以《驾校学员意外伤害保险条款(2015版)为准</h3>
      </div>
    </div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#FFC281">立即投保</van-button>
    </div>
  </div>
</template>

<script>
import { getJsapiTicket, findCategoryByProductId } from "@/api/common";
export default {
  data() {
    return {
      itemIndex: 1,
      belongerId: "",
      platformId: "",
      categoryId: "",
      tabList: [],
    };
  },
  created() {
    document.title = "阳光保险驾考宝";
    this.belongerId = this.$route.query.belongerId || "";
    this.platformId = this.$route.query.platformId || "";
    this.findCategoryByProductId();
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_sinosig.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(res.data, sUrl, sImgUrl, "阳光保险驾考宝");
      }
    });
  },
  methods: {
    findCategoryByProductId() {
      findCategoryByProductId({ productId: 1 }).then((res) => {
        if (res.code == 0) {
          this.tabList = res.data.list;
          if (this.tabList.length > 0) {
            this.categoryId = this.tabList[0].id;
          }
        }
      });
    },
    handleGoClick() {
      this.$router.push({
        path: "/insure/driverform",
        query: {
          belongerId: this.belongerId,
          categoryId: this.categoryId,
          platformId: this.platformId,
        },
      });
    },
    onClick(name, title) {
      this.categoryId = name;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: #ecf5f6;
}
/deep/ .van-tab {
  background-color: #ffc281;
  font-size: 1.1rem;
  color: #323233;
  border-right: 2px solid #ff8e00;
}
/deep/ .van-tab:nth-of-type(3) {
  border-right: 0;
}
/deep/ .van-tab--active {
  background-color: #fff;
}
/deep/ .van-tabs__line {
  background-color: transparent;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bottom_img {
  margin: 5%;
  width: 90%;
  height: 100%;
  object-fit: cover;
}

.insure_header .category {
  //height: 53px;
  margin-top: -6px;
}

.insure_header .category .category_name {
  box-sizing: border-box;
  border: 0px #fff solid;
  height: 100%;
  width: 33.3%;
  float: left;
  line-height: 53px;
  font-size: 1.1rem;
  text-align: center;
  background-color: #ffc281;
}

.insure_header .category .active {
  background-color: #fff;
}

.insure_header .insure_img {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}
.insure_header .insure_box {
  width: 100%;
  //margin-left: 5%;
  //margin-right: 5%;
  background-color: white;
  padding: 1rem 1rem;
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    i {
      width: 5px;
      display: block;
      height: 1rem;
      background-color: #ff8e00;
      margin-right: 0.5rem;
      border-top-right-radius: 0.2rem;
      border-bottom-right-radius: 0.2rem;
    }
    label {
      height: 1rem;
      font-weight: bold;
      font-size: 1.1rem;
      color: #333333;
      line-height: 1.2rem;
    }
  }
  .content {
    width: 100%;
    .content-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #f2f2f2;
      padding: 1rem 0;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-size: 1rem;
          color: #292929;
          font-weight: bold;
        }
        .right {
          font-size: 1.3rem;
          color: #292929;
          font-weight: bold;
          span {
            font-size: 0.8rem;
          }
        }
      }
      .center {
        font-size: 0.8rem;
        color: #292929;
        font-weight: 500;
      }
      .bottom {
        font-size: 0.8rem;
        color: #b8b8b8;
        font-weight: 500;
      }
    }
  }
}

.insure {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  right: 0.5rem;
  bottom: 1.5rem;
  position: fixed;
  border: 0.01rem solid #e9e9e9;
  background-color: #57b4ff;
  color: #fff;
}

.insure img {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.25rem;
  margin-top: 0.1rem;
}

.insure p {
  font-size: 0.25rem;
  margin-left: 0.25rem;
  margin-top: -0.08rem;
}

.nextbtn {
  text-align: center;
  margin-top: -5px;
}

.nextbtn .next {
  width: 100%;
  height: 1rem;
  line-height: 0.8rem;
  text-align: center;
  font-size: 0.4rem;
  border: 0;
  position: fixed;
  bottom: 0;
  left: 0;
}

#explain {
  color: #fff;
  margin-left: 6%;
  width: 88%;
}

#explain > h2 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
}

#explain > h3 {
  font-size: 0.75rem;
  letter-spacing: 0.04rem;
  line-height: 1.3rem;
  font-weight: 500;
}
.button-save {
  /deep/ .van-button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    // color: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/insure_driver.vue